export const MATCHINGPROFILE = 'MATCHINGPROFILE'
export const REQUIREMENTPROFILE = 'REQUIREMENTPROFILE'
export const TALENTPROFILE = 'TALENTPROFILE'
